/**
 * HOF comparator. Returns new comparator with reversed order of given
 * comparator.
 *
 * @param cmp
 */
export const reverse = (cmp) => (a, b) => -cmp(a, b);
